import { render, staticRenderFns } from "./GiVendorCommit.vue?vue&type=template&id=5c66f860&scoped=true&"
import script from "./GiVendorCommit.vue?vue&type=script&lang=js&"
export * from "./GiVendorCommit.vue?vue&type=script&lang=js&"
import style0 from "./GiVendorCommit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GiVendorCommit.vue?vue&type=style&index=1&id=5c66f860&scoped=true&lang=css&"
import style2 from "./GiVendorCommit.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66f860",
  null
  
)

export default component.exports